<template>
  <div class="timeline-box" @click.stop="">
    <div class="top-info-box" v-if="pluginJson">
      <div class="img-box" v-if="pluginJson[activeIndex].thumbnail">
        <img :src="pluginJson[activeIndex].thumbnail" alt="">
      </div>
      <div class="info-box" :class="{'noImage': !pluginJson[activeIndex].thumbnail}">
        <!--<h2>地震</h2>-->
        <vue-scroll>
          <div class="intro" v-html="util.fixIntro(pluginJson[activeIndex].intro)"></div>
        </vue-scroll>
      </div>
    </div>

    <div class="bottom-swiper-box">
      <div class="timeline-swiper">
        <div id="timelineSwiper" class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide circle-box" v-for="(item, index) in pluginJson" :key="index">
              <div class="circle"></div>
              <div class="white-circle"></div>
            </div>
          </div>
          <div class="swiper-button-next"></div>
          <div class="swiper-button-prev"></div>
        </div>
        <div class="year-box" v-if="pluginJson">{{pluginJson[activeIndex].name}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'dizhenHistory',
  props: {
    pluginJson: {
      type: Array
    },
    pluginIndex: {
      type: String
    }
  },
  data () {
    return {
      activeIndex: 0
    }
  },
  created () {
    console.log(this.pluginJson)
  },
  mounted () {
    let that = this
    this.swiper = new window.Swiper('#timelineSwiper', {
      slidesPerView: 5,
      centeredSlides: true,
      paginationClickable: true,
      mousewheelControl: true,
      prevButton: '.swiper-button-prev',
      nextButton: '.swiper-button-next',
      onTransitionEnd: function (swiper) {
        that.changeIndex(swiper.realIndex)
      }
    })
  },
  methods: {
    changeIndex (index) {
      if (this.activeIndex !== index) {
        this.activeIndex = index
      }
    }
  }
}

</script>

<style lang="scss">
  @function rem($px) {
    @return $px * (1/40) * 1rem;
  }

  .timeline-box{
    .top-info-box{
      box-sizing: border-box;
      border: 1px solid #FFE1BE;
      background: rgba(25, 35, 70, 0.75);
      box-shadow: 0px 12px 12px 0px rgba(30, 46, 79, 0.5);
      border-radius: rem(12);
      width: rem(1000);
      height: rem(440);
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      left: 50%;
      top: rem(112);
      margin-left: rem(-500);
      padding: rem(40);
      .img-box{
        width: rem(480);
        height: rem(360);
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: rem(40);
        position: relative;
        font-size: 0;
        img{
          max-width: rem(480);
          max-height: rem(360);
          border-radius: rem(10);
        }
        &::after{
          content: ' ';
          width: 1px;
          height: rem(360);
          background: #FFE1BE;
          position: absolute;
          right: rem(-11);
          top: 0;
        }
      }
      .info-box{
        width: rem(398);
        display: flex;
        align-items: center;
        flex-direction: column;
        &.noImage{
          width: rem(800);
        }
        h2{
          width: 100%;
          font-size: rem(24);
          line-height: rem(30);
          color: #FFE1BE;
          margin-bottom: rem(6);
          text-align: left;
        }
        .intro{
          font-size: rem(14);
          color: #FFFFFF;
          line-height: rem(20);
          text-align: justify;
          max-height: rem(140);
          p{
            /*text-indent: 2em;*/
          }
        }
      }
    }

    .bottom-swiper-box{
      width: 100%;
      height: rem(102);
      position: absolute;
      left: 0;
      top: rem(558);
      background: rgba(25, 35, 70, 0.65);
      box-shadow: 0px 12px 12px 0px rgba(30, 46, 79, 0.5);
      border-top: 1px solid #FFE1BE;
      border-bottom: 1px solid #FFE1BE;
      .timeline-swiper{
        width: rem(1000);
        height: rem(102);
        margin: 0 auto;
        .circle-box{
          height: rem(102);
          position: relative;
          .circle{
            width: rem(10);
            height: rem(10);
            position: absolute;
            left: 50%;
            top: 50%;
            margin-left: rem(-5);
            margin-top: rem(-5);
            background: #FFE1BE;
            border-radius: 50%;
            &::before{
              content: ' ';
              width: rem(14);
              height: rem(14);
              border: 1px solid #FFE1BE;
              border-radius: 50%;
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate3d(-50%, -50%, 0);
            }
          }
          &::after{
            content: ' ';
            width: rem(8);
            height: rem(8);
            background: #ffffff;
            border-radius: 50%;
            position: absolute;
            right: rem(-4);
            top: 50%;
            margin-top: rem(-4);
          }
          &:nth-last-of-type(1){
            &::after{
              display: none;
            }
          }
        }

        .swiper-button-next {
          width:rem(56);
          height: rem(32);
          background: url('../assets/img/pc/rightbg.png') no-repeat 0 0;
          background-size: 100% 100%;
          right: 0;
          margin-top: rem(-16);
          &::after{
            content: ' ';
            width:rem(24);
            height: rem(24);
            background-image : url('../assets/img/marker/next_btn.png');
            background-size: rem(24) rem(24);
            position: absolute;
            right: rem(2);
            top: 50%;
            margin-top: rem(-12);
            transform: rotateZ(-90deg);
          }
        }

        .swiper-button-prev {
          width:rem(56);
          height: rem(32);
          background: url('../assets/img/pc/rightbg.png') no-repeat 0 0;
          background-size: 100% 100%;
          transform: rotateZ(180deg);
          left: 0;
          margin-top: rem(-16);
          &::after{
            content: ' ';
            width:rem(24);
            height: rem(24);
            background-image : url('../assets/img/marker/next_btn.png');
            background-size: rem(24) rem(24);
            position: absolute;
            right: rem(2);
            top: 50%;
            margin-top: rem(-12);
            transform: rotateZ(-90deg);
          }
        }
      }
      .year-box{
        width: rem(106);
        height: rem(90);
        position: absolute;
        left: 50%;
        top: 50%;
        margin-top: rem(-45);
        margin-left: rem(-53);
        z-index: 2;
        background: linear-gradient(to bottom, rgba(25, 35, 70, 0) 0%, rgba(25, 35, 70, 1) 30%, rgba(25, 35, 70, 1) 70%, rgba(25, 35, 70, 0) 100%);
        font-size: rem(36);
        font-weight: 500;
        color: #FFE1BE;
        line-height: rem(90);
        letter-spacing: rem(2);
        text-align: center;
        pointer-events: none;
        &::before{
          content: ' ';
          width: 2px;
          height: rem(90);
          position: absolute;
          left: 0;
          top: 50%;
          margin-top: rem(-45);
          background: linear-gradient(to bottom, rgba(255, 225, 190, 0) 0%, rgba(255, 225, 190, 1) 30%, rgba(255, 225, 190, 1) 70%, rgba(255, 225, 190, 0) 100%);
        }
        &::after{
          content: ' ';
          width: 2px;
          height: rem(90);
          position: absolute;
          right: 0;
          top: 50%;
          margin-top: rem(-45);
          background: linear-gradient(to bottom, rgba(255, 225, 190, 0) 0%, rgba(255, 225, 190, 1) 30%, rgba(255, 225, 190, 1) 70%, rgba(255, 225, 190, 0) 100%);
        }
      }
    }
  }

</style>
